import OpenMeteoData from '../models/Weather';
import { apiClient } from './ApiService';
import { makeRequest } from './RequestService';

const getTelementryData = () => apiClient.get<any>('/telemetry');

const getTimeZoneFromLatLong = (lat: number, long: number) => {
  const TIMEZONE_API_KEY = '2AQOY8TY6SKZ';
  const url = `https://api.timezonedb.com/v2.1/get-time-zone?key=${TIMEZONE_API_KEY}&format=json&by=position&lat=${lat}&lng=${long}`;
  return makeRequest<any>('', url, { method: 'GET' }, false);
};

const getAddressFromLatLong = (lat: string, long: string) => {
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${long},${lat}.json?access_token=pk.eyJ1IjoianVsaWFub2VzIiwiYSI6ImNrOGNwbXVzbTA2bnMzZW95bmhvemIwbGkifQ.vHzrkhopow_IrtZm5yP5iA`;
  return makeRequest<any>('', url, { method: 'GET' }, false);
};

const moveGimbal = (pitch: number, yaw: number) => {
  const url = `/gimbal/angle_step/${pitch}/${yaw}`;
  return apiClient.get<any>(url);
};

const setGimbal = (pitch: number, yaw: number) => {
  const url = `/gimbal/angle/${pitch}/${yaw}`;
  return apiClient.get<any>(url);
};

const getWeatherData = (lat: number | string, long: number | string): Promise<OpenMeteoData> => {
  const url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${long}&current=temperature_2m,wind_speed_10m,wind_gusts_10m,wind_direction_10m,weather_code,relative_humidity_2m,precipitation&daily=weather_code,temperature_2m_max,temperature_2m_min,precipitation_sum,precipitation_probability_max,wind_speed_10m_max,wind_direction_10m_dominant&timezone=auto&forecast_days=3`;
  return makeRequest<OpenMeteoData>('', url, { method: 'GET' }, false, true);
};

const getWeatherDataWithUnits = (
  lat: number | string,
  long: number | string,
  temperatureUnit: 'celsius' | 'fahrenheit' = 'celsius'
): Promise<OpenMeteoData> => {
  const url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${long}&current=temperature_2m,wind_speed_10m,wind_gusts_10m,wind_direction_10m,weather_code,relative_humidity_2m,precipitation&daily=weather_code,temperature_2m_max,temperature_2m_min,precipitation_sum,precipitation_probability_max,wind_speed_10m_max,wind_direction_10m_dominant&timezone=auto&forecast_days=3&temperature_unit=${temperatureUnit}`;
  return makeRequest<OpenMeteoData>('', url, { method: 'GET' }, false, true);
};

export interface CameraZoom {
  zoomLevel: number;
}

const isInCameraZoomRange = (zoom: number) => zoom >= 1 && zoom <= 6;

const updateCameraZoom = ({ zoomLevel }: CameraZoom) => {
  if (!isInCameraZoomRange(zoomLevel)) {
    throw new Error('Invalid camera zoom level');
  }
  const floatZoomStr = Number(zoomLevel).toFixed(1);
  const url = `/camera/zoom/${floatZoomStr}`;
  return apiClient.get<any>(url);
};

export const TelemetryService = {
  getTelementryData,
  getTimeZoneFromLatLong,
  getAddressFromLatLong,
  moveGimbal,
  setGimbal,
  getWeatherData,
  getWeatherDataWithUnits,
  updateCameraZoom
};
